import { useReducer } from 'react';

const initialState = {
  currentOptotypes: [],
  optotypeSize: 0,
  crowdedOptotype: false,
  highlightedOptotype: null,
};

const optimaReducer = (existingData, action) => {
  switch (action.type) {
    case 'SET_CURRENT_OPTOTYPES':
      return { ...existingData, currentOptotypes: action.payload, highlightedOptotype: null };
    case 'SET_OPTOTYPE_SIZE':
      return { ...existingData, optotypeSize: action.payload };
    case 'SET_OPTOTYPE_CROWDING':
      return { ...existingData, crowdedOptotype: action.payload };
    case 'SET_HIGHLIGHTED_OPTOTYPE':
      return { ...existingData, highlightedOptotype: action.payload };
    default:
      return existingData;
  }
};

export const useOptotypeData = () => {
  const [currentOptotypeData, updateOptotypeData] = useReducer(optimaReducer, initialState);
  return { currentOptotypeData, updateOptotypeData };
};
